import React, { useEffect, useRef } from 'react';
import { toast, Toaster } from 'sonner';
import { CONSTANTS } from '../utils/constants';
const BUYERS = [{
  name: 'Martín R.',
  city: 'Buenos Aires'
}, {
  name: 'Laura P.',
  city: 'Morón'
}, {
  name: 'Diego S.',
  city: 'Lomas de Zamora'
}, {
  name: 'Camila G.',
  city: 'San Martín'
}, {
  name: 'Federico L.',
  city: 'Córdoba'
}, {
  name: 'Valentina M.',
  city: 'Rosario'
}, {
  name: 'Nicolás A.',
  city: 'La Plata'
}, {
  name: 'Sofía T.',
  city: 'Quilmes'
}, {
  name: 'Gonzalo R.',
  city: 'Mendoza'
}, {
  name: 'Florencia D.',
  city: 'Tucumán'
}, {
  name: 'Matías B.',
  city: 'Mar del Plata'
}, {
  name: 'Julieta C.',
  city: 'Avellaneda'
}];
export const PurchasePopup: React.FC = () => {
  const timeoutRef = useRef<NodeJS.Timeout>();
  useEffect(() => {
    const showPopup = () => {
      const buyer = BUYERS[Math.floor(Math.random() * BUYERS.length)];
      toast.custom(t => <div className="rounded-xl shadow-lg border p-4 flex items-center gap-4 w-full max-w-sm" style={{
        background: 'var(--bg-card)',
        borderColor: 'var(--border-gold)'
      }} data-id="element-155">
            <img src={CONSTANTS.IMAGES.MAIN_PRODUCT} alt="Product Thumbnail" className="w-16 h-16 object-cover rounded-md" data-id="element-156" />
            <div className="flex-1" data-id="element-157">
              <p className="font-bold text-sm" style={{
            color: 'var(--text-primary)'
          }} data-id="element-158">
                {buyer.name} de {buyer.city}
              </p>
              <p className="text-xs mt-1" style={{
            color: 'var(--text-secondary)'
          }} data-id="element-159">
                Acaba de adquirir este producto
              </p>
              <p className="text-xs font-bold mt-1 flex items-center gap-1" style={{
            color: 'var(--gold)'
          }} data-id="element-160">
                <span className="w-2 h-2 rounded-full inline-block" style={{
              background: 'var(--gold)'
            }} data-id="element-161"></span>
                Hace unos instantes
              </p>
            </div>
          </div>, {
        duration: 4000
      });
      const nextDelay = Math.floor(Math.random() * (30000 - 15000 + 1) + 15000);
      timeoutRef.current = setTimeout(showPopup, nextDelay);
    };
    timeoutRef.current = setTimeout(showPopup, 10000);
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);
  return <Toaster position="bottom-left" data-id="element-162" />;
};